import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=1f2d5da8&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"
import style0 from "./TabHeader.vue?vue&type=style&index=0&id=1f2d5da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d5da8",
  null
  
)

export default component.exports